var _rect, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEn(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 6,
    y: 6,
    width: 36,
    height: 36,
    rx: 3,
    fill: "#012169"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24 20.5L42 9V15.5L34 21H24V20.5Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M24 27.5L6 39V32.5L14 27H24V27.5Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M24 20.5L6 9V15.5L14 21H24V20.5Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M24 27.5L42 39V32.5L34 27H24V27.5Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M19 19V6H29V19H42V29H29V42H19V29H6V19H19Z",
    fill: "white"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M21 21V6H27V21H42V27H27V42H21V27H6V21H21Z",
    fill: "#C8102E"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M42 10.5L29 19H32.5L42 13V10.5Z",
    fill: "#C8102E"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M6 12L17 19H13.5L6 14V12Z",
    fill: "#C8102E"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M6 37.5L19 29H15.5L6 35V37.5Z",
    fill: "#C8102E"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M42 36L31 29H34.5L42 34V36Z",
    fill: "#C8102E"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEn);
export default __webpack_public_path__ + "static/media/EN.ab19de9558d7b117c47444ee80f8fb75.svg";
export { ForwardRef as ReactComponent };